import {
  INTERNSHIP_RELATIONSHIP_ID,
  SELF_EMPLOYED_RELATIONSHIP_ID,
  CNPJ_RELATIONSHIP_ID,
  COOPERATIVE_MEMBER_RELATIONSHIP_ID,
  ASSOCIATE_RELATIONSHIP_ID,
  PARTNER_RELATIONSHIP_ID,
} from '@convenia/helpers/modules/relationships'

export const relationships = [
  INTERNSHIP_RELATIONSHIP_ID,
  SELF_EMPLOYED_RELATIONSHIP_ID,
  CNPJ_RELATIONSHIP_ID,
  COOPERATIVE_MEMBER_RELATIONSHIP_ID,
  ASSOCIATE_RELATIONSHIP_ID,
  PARTNER_RELATIONSHIP_ID,
]

export const vacation = {
  'férias': {
    default: 'férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'recesso' ])),
  },
  'as férias': {
    default: 'as férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'o recesso' ])),
  },
  'das férias': {
    default: 'das férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'do recesso' ])),
  },
  'estas férias': {
    default: 'estas férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'este recesso' ])),
  },
  'suas férias': {
    default: 'suas férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'seu recesso' ])),
  },
  'Novas férias': {
    default: 'Novas férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Novo recesso' ])),
  },
  'Período das férias': {
    default: 'Período das férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Período do recesso' ])),
  },
  'Concluída': {
    default: 'Concluída',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Concluído' ])),
  },
  'Aprovada': {
    default: 'Aprovada',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Aprovado' ])),
  },
  'Férias aprovadas': {
    default: 'Férias aprovadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso aprovado' ])),
  },
  'Férias recusadas': {
    default: 'Férias recusadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso recusado' ])),
  },
  'Cancelada': {
    default: 'Cancelada',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Cancelado' ])),
  },
  'Férias canceladas': {
    default: 'Férias canceladas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso cancelado' ])),
  },
  'Recusada': {
    default: 'Recusada',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recusado' ])),
  },
  'férias vencidas': {
    default: 'férias vencidas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'recessos vencidos' ])),
  },
  'uma férias vencida': {
    default: 'uma férias vencida',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'um recesso vencido' ])),
  },
  'Férias em processamento colab': {
    default: 'Suas férias estão sendo processadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Seu recesso está sendo processado' ])),
  },
  'Férias em processamento admin': {
    default: 'As férias estão sendo processadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'O recesso está sendo processado' ])),
  },
  'Férias proporcionais': {
    default: 'Férias proporcionais',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso proporcional' ])),
  },
  'Férias solicitadas': {
    default: 'Férias solicitadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso solicitado' ])),
  },
  'Férias adicionadas': {
    default: 'Férias adicionadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso adicionado' ])),
  },
  'foram habilitadas': {
    default: 'foram habilitadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'foi habilitado' ])),
  },
  'foram desabilitadas': {
    default: 'foram desabilitadas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'foi desabilitado' ])),
  },
  'foram removidas': {
    default: 'foram removidas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'foi removido' ])),
  },
  'tiradas': {
    default: 'tiradas',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'tirados' ])),
  },
  'Férias': {
    default: 'Férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recessos' ])),
  },
  'Status de férias': {
    default: 'Férias',
    ...Object.fromEntries(relationships.map(relationship => [ relationship, 'Recesso' ])),
  },
}
